import { DisplayNews } from './DisplayNews'
import { DisplayDescription } from './DisplayDescription'
import { DisplayTitle } from './DisplayTitle'

export { DisplayDescription, DisplayNews, DisplayTitle }
